module.exports = __webpack_public_path__ + "assets/img/img17.1ce1647a.png";